module.exports = {
          srcSet: __webpack_public_path__ + "images/2021-b296d1ad83812b49326cd31c9bff3b76-320.jpg"+" 320w"+","+__webpack_public_path__ + "images/2021-d672b432f4b8b536aa6b4a4c7b8a041e-370.jpg"+" 370w",
          images:[ {path: __webpack_public_path__ + "images/2021-b296d1ad83812b49326cd31c9bff3b76-320.jpg",width: 320,height: 251},{path: __webpack_public_path__ + "images/2021-d672b432f4b8b536aa6b4a4c7b8a041e-370.jpg",width: 370,height: 290}],
          src: __webpack_public_path__ + "images/2021-b296d1ad83812b49326cd31c9bff3b76-320.jpg",
          toString:function(){return __webpack_public_path__ + "images/2021-b296d1ad83812b49326cd31c9bff3b76-320.jpg"},
          
          width: 320,
          height: 251
        }